import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SellerComponent } from './components/seller.component';

const routes: Routes = [
  {
    path: '', children: [
      {path: ':id', component: SellerComponent},
      {path: '**', component: SellerComponent}
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SellerRoutingModule {
}
